export type PovertyGuidelineRegion = "contiguous" | "alaska" | "hawaii";

export const FEDERAL_POVERTY_GUIDELINE_YEAR = 2025;

export const FEDERAL_POVERTY_GUIDELINES: Record<
  PovertyGuidelineRegion,
  {
    label: string;
    base: number[];
    additionalPerson: number;
  }
> = {
  contiguous: {
    label: "48 contiguous states and D.C.",
    base: [15650, 21150, 26650, 32150, 37650, 43150, 48650, 54150],
    additionalPerson: 5500,
  },
  alaska: {
    label: "Alaska",
    base: [19550, 26430, 33310, 40190, 47070, 53950, 60830, 67710],
    additionalPerson: 6880,
  },
  hawaii: {
    label: "Hawaii",
    base: [17990, 24320, 30650, 36980, 43310, 49640, 55970, 62300],
    additionalPerson: 6330,
  },
};

export function getPovertyGuideline(
  familySize: number,
  region: PovertyGuidelineRegion
): number {
  const normalizedFamilySize = Math.max(1, Math.floor(familySize || 1));
  const guideline = FEDERAL_POVERTY_GUIDELINES[region];

  if (normalizedFamilySize <= guideline.base.length) {
    return guideline.base[normalizedFamilySize - 1];
  }

  return (
    guideline.base[guideline.base.length - 1] +
    (normalizedFamilySize - guideline.base.length) * guideline.additionalPerson
  );
}
